import React from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import { ADMIN_LEASING_EXPENSE_TYPES_READ, ADMIN_LEASING_EXPENSE_TYPES_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';
import HeaderPortal from 'components/layout/HeaderPortal';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import LeasingExpenseTypesListBrowser from './LeasingExpenseTypesListBrowser';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_LEASING_EXPENSE_TYPES_WRITE} withForbiddenPage={false}>
          <IconButton
            onClick={() => historyContext.push(`/leasingExpenseTypes/new`)}
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Add')}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_EXPENSE_TYPES_READ}>
        <LeasingExpenseTypesListBrowser />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
